import { assertUnreachable } from "@aidkitorg/types/lib/typechecks";
import { useConnectionModal } from "./ConnectionModalContext";
import { ConnectionModalSearchPage } from "./ConnectionModalSearchPage";
import { ConnectionModalSourcePage } from "./ConnectionModalSourcePage";
import { ConnectionModalPendingPage } from "./ConnectionModalPendingPage";
import { ConnectionModalAdditionalQuestionPage } from "./ConnectionModalAdditionalQuestionPage";
import { ConnectionModalSelectAccountPage } from "./ConnectionModalSelectAccountPage";
import { ConnectionModalErrorPage } from "./ConnectionModalErrorPage";

export function ConnectionModalContents() {
  const { state } = useConnectionModal();

  switch (state.stage) {
    case "search":
      return <ConnectionModalSearchPage />;
    case "source":
      return <ConnectionModalSourcePage state={state} />;
    case "pending":
      return <ConnectionModalPendingPage state={state} />;
    case "additional_question":
      return <ConnectionModalAdditionalQuestionPage state={state} />;
    case "select_account":
      return <ConnectionModalSelectAccountPage state={state} />;
    case "error":
      return <ConnectionModalErrorPage state={state} />;
    default:
      assertUnreachable(state);
  }
}
